import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export interface GetCustomerCategoryResponse {
    customer_category_idx: number;
    product_category_idx: number;
    category_name: string;
    category_image: string;
    wreath_option: boolean;
    union_option: boolean;
    flag: boolean;
}
export const useGetCustomerCategory = (customerId: number): UseQueryResult<GetCustomerCategoryResponse[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    return useQuery<GetCustomerCategoryResponse[], Error>({
        queryKey: ["getCustomerCategory", customerId],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_customer_category.replace(":customer_idx", customerId.toString())}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                };
            }
            return undefined;
        },
    });
};
